var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUrl = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#3A414C",
  fillRule: "nonzero",
  d: "M4.71 12.5A2.79 2.79 0 0 1 7.5 9.71h3.6V8H7.5A4.5 4.5 0 0 0 3 12.5C3 14.984 5.016 17 7.5 17h3.6v-1.71H7.5a2.79 2.79 0 0 1-2.79-2.79m3.69.9h7.2v-1.8H8.4zM16.5 8h-3.6v1.71h3.6a2.79 2.79 0 0 1 2.79 2.79 2.79 2.79 0 0 1-2.79 2.79h-3.6V17h3.6c2.484 0 4.5-2.016 4.5-4.5S18.984 8 16.5 8"
})));
export { SvgUrl as ReactComponent };
export default __webpack_public_path__ + "static/media/url.38db3ab6.svg";